<div class="text-center" *ngIf="exibir">
	<img src="assets/images/nenhum_resultado.png" alt="Nenhum resultado encontrado" />
	<p class="text-up-03 text-mint-cool-vivid-40 text-weight-semi-bold">{{ titulo }}</p>
	<p>{{ mensagem }}</p>
</div>
